import { controlService } from "./requests.ts";
import { toast } from 'react-toastify';
import { store } from "../../Redux/Store";
import { ChangeData, ChangeLayout, ChangeEdit, ChangeEquipamentList, ChangeLayoutsList, ChangeEquipament, ChangeLoading, ChangeComand, 
    ChangeModalCode, sendingCode, ChangeLastUpdate, LogOut, ChangeModalComands, ChangeAlarms, ChangeModalAlarms, ChangeCards, 
    ChangeControlCities, ChangeControlCity} from "../../Redux/Actions/index.js";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento do Controle de equipamentos
 */
export class ControlClass {
    constructor(navigate) {
        this.lastUpdate = null;
        this.codeField = null;
        this.isDefault = false;
        this.layoutId = null;
        this.layouts = [];
        this.alarms = null;
        this.columns_out = [];
        this.Equipaments = [];
        this.Equipament = null;
        this.name = null;
        this.data = [];
        this.comands = [];
        this.showComands = [];
        this.comandsModal = [];
        this.showComandsModal = [];
        this.month = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez']
        this.navigate = navigate;
        this.com_timeout = null;
    }

    start(codeField, detailscontroller, equipamento){
        this.Equipament = equipamento;
        this.codeField = codeField;
        // this.getActiveCode(); => Alterado para não começar desativada 
        this.getPocos();
        this.Equipament ? this.getActiveLayout() : console.log('Sem equipamento');
        this.detailscontroller = detailscontroller;
    }

    // Função para verificar se o usuário ja possui um código ativo
    getActiveCode(){
        let AuthExpire = new Date(localStorage.getItem('AuthExpire'));
        if(AuthExpire){
            let currentTime = Date.now();
            currentTime = new Date(currentTime);
            let diff = AuthExpire.valueOf() - currentTime.valueOf();
            if(diff > 10){
                store.dispatch(ChangeModalCode(false));
            }
        }
    }

    // Função para buscar os poços
    async getPocos(){
        try {
            const pocoList = await controlService.getPocosByUser();
            let List = [{id: '', nome: i18n.t("select.equipment")}];
            List.push(...pocoList.authorized_equipments);
            store.dispatch(ChangeEquipamentList(List));
            this.Equipaments = List;
            if(store.getState().controlReducer?.city){
                this.filterEquipaments(store.getState().controlReducer.city);
            }
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Função para listagem de layouts
    async getLayouts (){
        try {
            const layoutsList = await controlService.listLayouts(this.Equipament);
            if(layoutsList.length < 1){
                layoutsList.push(
                    {
                        'id': 'newlayout',
                        'active': true,
                        'name': 'padrão',
                    }
                );
            }
            store.dispatch(ChangeLayoutsList(JSON.parse(JSON.stringify(layoutsList))));
            this.layouts = layoutsList;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Função para pegar o layout ativo com os dados do poço
    async getActiveLayout(){
        try {
            store.dispatch(ChangeLoading(true));
            let currentLayout = await controlService.getActiveLayout(this.Equipament);
            if(currentLayout.default && this.layouts.length < 1){
                await this.createNewConfig(); 
                return;
            }
            this.updateLegend(currentLayout.ultima_atualizacao, currentLayout?.communication_timeout_minutes || 15);
            this.data = currentLayout.colunas;
            this.name = currentLayout.name;
            this.layoutId = currentLayout.id;
            let newCard;
            currentLayout.colunas.map(coluna => {
                coluna.cards.map(card => {
                    if(card.cards_comando.comandoPoco.active){
                        newCard = newCard ? newCard : card;
                    }
                    card.cards_comando.comando_variavel.map(item => {
                        if(parseFloat(item.variavel.valor)){
                            try {
                                item.variavel.valor = parseFloat(item.variavel.valor).toFixed(2);
                            } catch (error) {
                                
                            }
                        }
                        return item;
                    })
                    card.cards_comando.grupos.map(grupo => {
                        grupo.variaveis_agrupadas.map(item => {
                            if(parseFloat(item.variavel.valor)){
                                try {
                                    item.variavel.valor = parseFloat(item.variavel.valor).toFixed(2);
                                } catch (error) {
                                    
                                }
                            }
                            return item;
                        })
                        return grupo;
                    })
                    return card;
                })
                return coluna;
            })
            this.StartCards(newCard);
            store.dispatch(ChangeLayout(currentLayout.id, currentLayout.name));
            store.dispatch(ChangeData(JSON.parse(JSON.stringify(currentLayout.colunas))));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        store.dispatch(ChangeLoading(false));
    }

    // Função para criar um novo layout
    async createNewConfig(ignoreEdit){
        let isEdit = await this.VerifyLayout([]);
        if(!isEdit || ignoreEdit){
            store.dispatch(ChangeLoading(true));
            this.layouts.map(layout => layout.active = false);
            this.name = 'padrão';
            this.layoutId = 'newlayout';
            this.layouts = [
                ...this.layouts,
                {
                    'id': 'newlayout',
                    'active': true,
                    'name': 'padrão',
                }
            ];
            store.dispatch(ChangeLayoutsList(JSON.parse(JSON.stringify(this.layouts))));
            store.dispatch(ChangeLayout('newlayout', 'padrão'));
            try {
                let currentLayout = await controlService.getDefautLayout(this.Equipament);
                this.updateLegend(currentLayout.ultima_atualizacao, currentLayout?.communication_timeout_minutes || 15);
                this.data = currentLayout.colunas;
                let newCard;
                currentLayout.colunas.map(coluna => {
                    coluna.cards.map(card => {
                        if(card.cards_comando.comandoPoco.active){
                            newCard = newCard ? newCard : card;
                        }
                        card.cards_comando.comando_variavel.map(item => {
                            if(parseFloat(item.variavel.valor)){
                                try {
                                    item.variavel.valor = parseFloat(item.variavel.valor).toFixed(2);
                                } catch (error) {
                                    
                                }
                            }
                            return item;
                        })
                        card.cards_comando.grupos.map(grupo => {
                            grupo.variaveis_agrupadas.map(item => {
                                if(parseFloat(item.variavel.valor)){
                                    try {
                                        item.variavel.valor = parseFloat(item.variavel.valor).toFixed(2);
                                    } catch (error) {
                                        
                                    }
                                }
                                return item;
                            })
                            return grupo;
                        })
                        return card;
                    })
                    return coluna;
                })
                this.StartCards(newCard);
                store.dispatch(ChangeData(JSON.parse(JSON.stringify(currentLayout.colunas))));
                this.isDefault = true;
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
            }
            store.dispatch(ChangeLoading(false));
        }else{
            toast(i18n.t("message.control-service.create-new-config"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    // Função para verificar se houve mudança no layout
    async VerifyLayout(newData){
        if(this.isDefault){return true}
        let isEdit = false;
        newData.map((temp, index) => {
            if(temp.id !== this.data[index].id){
                isEdit = true;
            }
            temp.cards.map((card, indice) => {
                if(card.id !== this.data[index].cards[indice].id){
                    isEdit = true;
                }
                return null;
            })
            return null;
        })
        return isEdit;
    }

    // Função para mudar a visualização para um layout
    async viewLayout(view, ignoreEdit){
        let isEdit = ignoreEdit ? false : await this.VerifyLayout(store.getState().controlReducer.data);
        if(isEdit){
            toast(i18n.t("message.control-service.view-layout"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return;
        }
        store.dispatch(ChangeLoading(true));
        try {
            let currentLayout = await controlService.getLayout(this.Equipament, view);
            this.data = currentLayout.colunas;
            this.layoutId = currentLayout.id;
            this.name = currentLayout.name;
            let newCard;
            currentLayout.colunas.map(coluna => {
                coluna.cards.map(card => {
                    if(card.cards_comando.comandoPoco.active){
                        newCard = newCard ? newCard : card;
                    }
                    card.cards_comando.comando_variavel.map(item => {
                        if(parseFloat(item.variavel.valor)){
                            try {
                                item.variavel.valor = parseFloat(item.variavel.valor).toFixed(2);
                            } catch (error) {
                                
                            }
                        }
                        return item;
                    })
                    card.cards_comando.grupos.map(grupo => {
                        grupo.variaveis_agrupadas.map(item => {
                            if(parseFloat(item.variavel.valor)){
                                try {
                                    item.variavel.valor = parseFloat(item.variavel.valor).toFixed(2);
                                } catch (error) {
                                    
                                }
                            }
                            return item;
                        })
                        return grupo;
                    })
                    return card;
                })
                return coluna;
            })
            this.StartCards(newCard);
            store.dispatch(ChangeLayout(currentLayout.id, currentLayout.name));
            store.dispatch(ChangeData(JSON.parse(JSON.stringify(currentLayout.colunas))));
            this.layouts.map(layout => {
                if(layout.id === view){
                    layout.active = true;
                }else{
                    layout.active = false;
                }
                return layout;
            })
            store.dispatch(ChangeLayoutsList(JSON.parse(JSON.stringify(this.layouts))));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        store.dispatch(ChangeLoading(false));
    }

    // Função para excluir um layout
    async deleteLayout(layout){
        try {
            let response = await controlService.deleteLayout(layout);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            this.layouts = this.layouts.filter((id) => id.id !== layout);
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return;
        }
        if(this.layouts.length > 0){
            await this.viewLayout(this.layouts[0].id, true);
        }else{
            await this.createNewConfig(true);
        }
    }

    // Função para salvar o layout
    async saveLayout(save){
        if(!save){
            store.dispatch(ChangeData(JSON.parse(JSON.stringify(this.data))));
            store.dispatch(ChangeLayout(this.layoutId, this.name));
            store.dispatch(ChangeEdit(false));
            return;
        }
        let TempLayout = (JSON.parse(JSON.stringify(store.getState().controlReducer.data)));
        if(store.getState().controlReducer.layout.name === null || store.getState().controlReducer.layout.name === undefined || 
        store.getState().controlReducer.layout.name === ''){
            toast(i18n.t("message.control-service.save-layout"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return;
        }
        TempLayout.map((column, index) => {
            column.order = index; 
            column.cards.map((card, index) => card.order = index);
            return null;
        })
        try {
            let response = await controlService.editLayout(this.layoutId, TempLayout, this.columns_out, store.getState().controlReducer.layout.name, this.Equipament);
            response.columns_id.map(coluna => {
                TempLayout[coluna.order].id = coluna.id;
                coluna.cards.map(item => {
                    TempLayout[coluna.order].cards[item.order].id = item.id;
                    return null;
                })
                return null;
            })
            this.layoutId = response.layout_id;
            this.data = (JSON.parse(JSON.stringify(TempLayout)));
            store.dispatch(ChangeLayout(response.layout_id, store.getState().controlReducer.layout.name));
            store.dispatch(ChangeData(JSON.parse(JSON.stringify(TempLayout))));
            await this.getLayouts();
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            this.isDefault = false;
            this.columns_out = [];
        } catch (error) {
            console.log(error)
            store.dispatch(ChangeData(JSON.parse(JSON.stringify(this.data))));
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        store.dispatch(ChangeEdit(false));
    }

    // Função para verificar tamanho maximo do nome do layout
    ChangeLayoutName(name){
        if(name.length > 16){
            toast(i18n.t("message.control-service.change-layout-name"), {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }else{
            store.dispatch(ChangeLayout(this.layoutId, name));
        }
    }

    // Função para alterar o equipamento
    ChangeEquipment(newEquipament, teste){
        if(this.comands.length > 0){
            toast(i18n.t("message.control-service.change-equipment"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return;
        }
        if(newEquipament === '' || newEquipament === null || newEquipament === undefined){
            toast(i18n.t("message.select-equipment"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return;
        }
        this.Equipament = newEquipament;
        store.dispatch(ChangeEquipament(newEquipament));
        if(window.location.pathname.split('/')[2] !== 'controle'){
            this.navigate(`/controle/${newEquipament}`);
        }
        if(teste){
            this.getActiveLayout();
            this.getLayouts();
        }
    }
    
    // Função para remover a coluna
    removeColumn (column){
        if(column.cards.length > 0){
            toast(i18n.t("message.control-service.remove-column"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }else{
            let newData = [...store.getState().controlReducer.data];
            let newOrder = newData.filter(item => item.id !== column.id);

            store.dispatch(ChangeData((newOrder)));
            this.columns_out.push(column.id);
        }
    }

    // Função para adicionar nova Coluna
    addColumn (){
        var newData = [...store.getState().controlReducer.data];
        let newColumn = newData.length + 1;
        let newId = 'coluna-' + newColumn;

        let newColumnItem = {
            id: newId,
            name: 'Nova seção',
            layout_id: '',
            order: null,
            cards:[],
        };
        newData.push(newColumnItem);
        store.dispatch(ChangeData(newData));
    }

    // Função para alterar o titulo da coluna
    changeTitle (column) {
        if(column === false){
            toast(i18n.t("message.control-service.change-title"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return;
        }
        let newData = {...store.getState().controlReducer.data};
        let newColumn = Object.entries(newData).find(item => item[1].id === column.id);
        newData[newColumn[0]] =  column;
        newData = Object.values(newData);

        store.dispatch(ChangeData(newData));
    }

    // Função para enviar o código de autenticação
    async sendCode(code){
        if(code === null || code === ''){return}
        store.dispatch(sendingCode(true));
        try {
            const response = await controlService.sendAuthCode(code);
            if(response.message === 'Código valido!'){
                try {
                    localStorage.setItem('AuthExpire', response.token_expiry);
                } catch (error) {
                    
                }
                toast(response.message, {
                    position: "top-center",
                    type: 'success',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                store.dispatch(ChangeModalCode(false));
                if(this.comands.length > 0){
                    store.dispatch(ChangeModalComands(true));
                }
            }
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        store.dispatch(sendingCode(false));
    }

    // Função para adicionar novo comando a lista de comandos a ser enviada
    addComand (newcomand, oldValue, name, onCancel, type){
        if(newcomand[1] === true){
            newcomand[1] = 1
        } 
        if(newcomand[1] === false){
            newcomand[1] = 0
        } 
        if((!parseFloat(newcomand[1]) && parseFloat(newcomand[1]) !== 0) || (newcomand[1] < 0 )){
            toast(i18n.t("message.control-service.add-command"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            onCancel();
            return;
        }
        let ValidComand = this.ValidateComand(newcomand);
        let isValidComand = ValidComand.isValidComand;
        let isNewComand = ValidComand.isNewComand;
        if(!isValidComand){return}
        if(oldValue === newcomand[1] && isNewComand){return}
        if(type === null || type === undefined){
            newcomand[1] = parseFloat(newcomand[1]);
        }
        if(isNewComand){
            this.showComands.push({
                'name': name,
                'oldValue': oldValue,
                'newValue': newcomand[1],
                'comando': newcomand,
                'type': type
            });
            this.comands.push(newcomand);
        }else if(parseFloat(this.showComands[ValidComand.comandIndex].oldValue) !== parseFloat(newcomand[1])){
            this.comands = this.comands.map(([comando, valor]) => (comando === newcomand[0] ? [comando, newcomand[1]] : [comando, valor]));
            this.showComands = this.showComands.map((tempcomand) => (tempcomand.name === name ? {...tempcomand, 'newValue': newcomand[1]} : tempcomand));
        }else{
            this.comands = this.comands.filter(([comando, valor]) => (comando !== newcomand[0]));
            this.showComands = this.showComands.filter((tempcomand) => (tempcomand.name !== name));
        }
        store.dispatch(ChangeComand(JSON.parse(JSON.stringify(this.showComands))));
        let data = JSON.parse(JSON.stringify(store.getState().controlReducer.data));
        let cards = JSON.parse(JSON.stringify(store.getState().controlReducer.cards));
        data.map(column => {
            column.cards.map(item => {
                if(item.cards_comando.switchvariable?.id === newcomand[0]){
                    item.cards_comando.switchvariable.valor = newcomand[1]
                }
                item.cards_comando.grupos.map(grupo => {
                    grupo.variaveis_agrupadas.map(variavel => {
                        if(variavel.variavel.id === newcomand[0]){
                            variavel.variavel.valor = newcomand[1]
                        }
                        if(variavel.variavel.alarmHH?.variavel.id === newcomand[0]){
                            variavel.variavel.alarmHH.variavel.valor = newcomand[1]
                        }
                        if(variavel.variavel.alarmH?.variavel.id === newcomand[0]){
                            variavel.variavel.alarmH.variavel.valor = newcomand[1]
                        }
                        if(variavel.variavel.alarmL?.variavel.id === newcomand[0]){
                            variavel.variavel.alarmL.variavel.valor = newcomand[1]
                        }
                        if(variavel.variavel.alarmLL?.variavel.id === newcomand[0]){
                            variavel.variavel.alarmLL.variavel.valor = newcomand[1]
                        }
                        return variavel
                    })
                    return grupo
                })
                item.cards_comando.comando_variavel.map(variavel => {
                    if(variavel.variavel.id === newcomand[0]){
                        variavel.variavel.valor = newcomand[1]
                    }
                    if(variavel.variavel.alarmHH?.variavel.id === newcomand[0]){
                        variavel.variavel.alarmHH.variavel.valor = newcomand[1]
                    }
                    if(variavel.variavel.alarmH?.variavel.id === newcomand[0]){
                        variavel.variavel.alarmH.variavel.valor = newcomand[1]
                    }
                    if(variavel.variavel.alarmL?.variavel.id === newcomand[0]){
                        variavel.variavel.alarmL.variavel.valor = newcomand[1]
                    }
                    if(variavel.variavel.alarmLL?.variavel.id === newcomand[0]){
                        variavel.variavel.alarmLL.variavel.valor = newcomand[1]
                    }
                    return variavel;
                })
                return item;
            })
            return column;
        })
        cards.cards.map(card => {
            card.grupo?.variaveis_agrupadas.map(variavel => {
                if(variavel.variavel.id === newcomand[0]){
                    variavel.variavel.valor = newcomand[1]
                }
                return variavel
            })
            if(card.variavel?.id === newcomand[0]){
                card.variavel.valor = newcomand[1]
            }
            if(card.switchvariable?.id === newcomand[0]){
                card.switchvariable.valor = newcomand[1]
            }
            return card;
        })
        store.dispatch(ChangeCards(JSON.parse(JSON.stringify(cards))));
        store.dispatch(ChangeData(JSON.parse(JSON.stringify(data))));

    }

    // Função para validar o comando
    ValidateComand (newcomand){
        let isValidComand = true;
        let isNewComand = true;
        let comandIndex = null;
        this.comands.map((comando, index) => {
            if(comando[0] === newcomand[0] && comando[1] === newcomand[1]){
                isValidComand = false
            }
            if(comando[0] === newcomand[0] && comando[1] !== newcomand[1]){
                isNewComand = false
                comandIndex = index
            }
            return null;
        })
        return{
            'isValidComand' : isValidComand,
            'isNewComand' : isNewComand,
            'comandIndex' : comandIndex,
        }
    }

    // Função para remover o comando da lista de comandos
    async removeComand(indice){
        if(this.comands.length === 1){
            store.dispatch(ChangeModalComands(false));
        }
        this.CancelComand(indice, this.showComands[indice].oldValue);
        this.comands = this.comands.filter((item, index)=> index !== indice);
        this.showComands = this.showComands.filter((item, index) => index !== indice);
        store.dispatch(ChangeComand(JSON.parse(JSON.stringify(this.showComands))));
    }

    // Função para cancelar os comandos
    CancelComand(indice, value){
        let data = JSON.parse(JSON.stringify(store.getState().controlReducer.data));
        let cards = JSON.parse(JSON.stringify(store.getState().controlReducer.cards));
        data.map(column => {
            column.cards.map(item => {
                if(item.cards_comando.switchvariable?.id === this.comands[indice][0]){
                    item.cards_comando.switchvariable.valor = value
                }
                item.cards_comando.grupos.map(grupo => {
                    grupo.variaveis_agrupadas.map(variavel => {
                        if(variavel.variavel.id === this.comands[indice][0]){
                            variavel.variavel.valor = value
                        }
                        if(variavel.variavel.alarmHH?.variavel.id === this.comands[indice][0]){
                            variavel.variavel.alarmHH.variavel.valor = value
                        }
                        if(variavel.variavel.alarmH?.variavel.id === this.comands[indice][0]){
                            variavel.variavel.alarmH.variavel.valor = value
                        }
                        if(variavel.variavel.alarmL?.variavel.id === this.comands[indice][0]){
                            variavel.variavel.alarmL.variavel.valor = value
                        }
                        if(variavel.variavel.alarmLL?.variavel.id === this.comands[indice][0]){
                            variavel.variavel.alarmLL.variavel.valor = value
                        }
                        return variavel;
                    })
                    return grupo;
                })
                item.cards_comando.comando_variavel.map(variavel => {
                    if(variavel.variavel.id === this.comands[indice][0]){
                        variavel.variavel.valor = value
                    }
                    if(variavel.variavel.alarmHH?.variavel.id === this.comands[indice][0]){
                        variavel.variavel.alarmHH.variavel.valor = value
                    }
                    if(variavel.variavel.alarmH?.variavel.id === this.comands[indice][0]){
                        variavel.variavel.alarmH.variavel.valor = value
                    }
                    if(variavel.variavel.alarmL?.variavel.id === this.comands[indice][0]){
                        variavel.variavel.alarmL.variavel.valor = value
                    }
                    if(variavel.variavel.alarmLL?.variavel.id === this.comands[indice][0]){
                        variavel.variavel.alarmLL.variavel.valor = value
                    }
                    return variavel;
                })
                return item;
            })
            return column;
        })
        cards.cards.map(card => {
            card.grupo?.variaveis_agrupadas.map(variavel => {
                if(variavel.variavel.id === this.comands[indice][0]){
                    variavel.variavel.valor = value
                }
                return variavel;
            })
            if(card.variavel?.id === this.comands[indice][0]){
                card.variavel.valor = value;
            }
            if(card.switchvariable?.id === this.comands[indice][0]){
                card.switchvariable.valor = value;
            }
            return card;
        })
        store.dispatch(ChangeCards(JSON.parse(JSON.stringify(cards))));
        store.dispatch(ChangeData(JSON.parse(JSON.stringify(data))));
    }

    // Função para enviar os comandos
    async sendComands(){
        try {
            const response = await controlService.sendMessage(this.Equipament, this.comands);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            this.comands = [];
            this.showComands = [];
            store.dispatch(ChangeComand([]));
            store.dispatch(ChangeModalComands(false));
        } catch (error) {
            console.log(error)
            if(error.message === 'Código inválido' || error.message === 'Sessão expirada'){
                toast(i18n.t("message.control-service.send-commands"), {
                    position: "top-center",
                    type: 'info',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                store.dispatch(ChangeModalComands(false));
                store.dispatch(ChangeModalCode(true));
                this.codeField.focus();
                return;
            }
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async cancelAllComands(){
        let data = JSON.parse(JSON.stringify(store.getState().controlReducer.data));
        let cards = JSON.parse(JSON.stringify(store.getState().controlReducer.cards));
        data.map(column => {
            column.cards.map(item => {
                if(item.cards_comando.switchvariable){
                    let oldvalue = this.showComands.filter(comand => comand.comando[0] === item.cards_comando.switchvariable.id)
                    if(oldvalue.length > 0){
                        item.cards_comando.switchvariable.valor = oldvalue[0].oldValue;
                    }
                }
                item.cards_comando.grupos.map(grupo => {
                    grupo.variaveis_agrupadas.map(variavel => {
                        let oldvalue = this.showComands.filter(comand => comand.comando[0] === variavel.variavel.id)
                        if(oldvalue.length > 0){
                            variavel.variavel.valor = oldvalue[0].oldValue;
                        }
                        return variavel;
                    })
                    return grupo;
                })
                item.cards_comando.comando_variavel.map(variavel => {
                    let oldvalue = this.showComands.filter(comand => comand.comando[0] === variavel.variavel.id)
                    if(oldvalue.length > 0){
                        variavel.variavel.valor = oldvalue[0].oldValue;
                    }
                    return variavel;
                })
                return item;
            })
            return column;
        })
        cards.cards.map(card => {
            card.grupo?.variaveis_agrupadas.map(variavel => {
                variavel.variavel.valor = variavel.variavel.oldValue;
                return variavel;
            })
            if(card.variavel){
                card.variavel.valor = card.variavel.oldValue;
            }
            if(card.switchvariable){
                card.switchvariable.valor = card.switchvariable.oldValue;
            }
            return card;
        })
        this.comands = [];
        this.showComands = [];
        store.dispatch(ChangeComand([]));
        store.dispatch(ChangeModalComands(false));
        
        store.dispatch(ChangeCards(JSON.parse(JSON.stringify(cards))));
        store.dispatch(ChangeData(JSON.parse(JSON.stringify(data))));
    }

    // Função para atualizar os dados exibidos
    async updateData(){
        if(this.Equipament && !store.getState().controlReducer.allowEdit && !store.getState().controlReducer.isTuorActive){
            try {
                let currentLayout = await controlService.getActiveLayout(this.Equipament);
                this.updateLegend(currentLayout.ultima_atualizacao, currentLayout?.communication_timeout_minutes || 15);
                let columns = currentLayout.colunas;
                // Altera os valores das váriaveis que não foram alteradas pelo usuário
                columns.map(coluna => {
                    coluna.cards.map(item => {
                        item.cards_comando.grupos.map(group => {
                            group.variaveis_agrupadas.map(variavel => {
                                if(parseFloat(variavel.variavel.valor)){
                                    try {
                                        variavel.variavel.valor = parseFloat(variavel.variavel.valor).toFixed(2);
                                    } catch (error) {
                                        
                                    }
                                }
                                this.comands.filter(comandId => {
                                    if(comandId[0] === variavel.variavel.id){
                                        variavel.variavel.valor = comandId[1];
                                    }
                                    return null;
                                })
                                return variavel;
                            })
                            return group;
                        })
                        item.cards_comando.comando_variavel.map(variavel => {
                            if(parseFloat(variavel.variavel.valor)){
                                try {
                                    variavel.variavel.valor = parseFloat(variavel.variavel.valor).toFixed(2);
                                } catch (error) {
                                    
                                }
                            }
                            this.comands.filter(comandId => {
                                if(comandId[0] === variavel.variavel.id){
                                    variavel.variavel.valor = comandId[1];
                                }
                                if(comandId[0] === item.cards_comando.switchvariable?.id){
                                    item.cards_comando.switchvariable.valor = comandId[1];
                                }
                                return null;
                            })
                            return variavel;
                        })
                        return item;
                    })
                    return coluna;
                })
                this.UpdateCards(columns);
                this.data = columns;
                this.name = currentLayout.name;
                this.layoutId = currentLayout.id;
                store.dispatch(ChangeData(JSON.parse(JSON.stringify(columns))));
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
            }
        }
    }

    // Função para alterar msg de ultima atualização
    updateLegend (update, timeout){
        let data = new Date(update);
        let currenttime = new Date();
        let com = Math.abs(data - currenttime);
        com = (Math.floor((com / 1000) / 60)) > timeout ? 3 : 0;
        let hour = data.getHours() + ':' + (data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes());
        let day = data.getDate() + ' ' + this.month[data.getMonth()];
        let newupdate = {
            'date': data,
            'day' : day,
            'hour' : hour,
            'Comunicacao': com,
        }
        store.dispatch(ChangeLastUpdate(newupdate));
    }

    // Função para exibir os alarmes
    ShowAlarms (name, l, ll, h, hh){
        let temp = store.getState().controlReducer.alarms
        temp = {
            ...temp,
            'name': name
        }
        if(hh){
            temp ={
                ...temp,
                'alarmHH': hh,
                'alarmH': h,
            }
        }else{
            temp ={
                ...temp,
                'alarmHH': null,
                'alarmH': null,
            }
        }
        if(ll){
            temp = {
                ...temp,
                'alarmLL': ll,
                'alarmL': l,
            }
        }else{
            temp = {
                ...temp,
                'alarmLL': null,
                'alarmL': null,
            }
        }
        store.dispatch(ChangeAlarms(temp));
        store.dispatch(ChangeModalAlarms(true));
    }

    // Função para adicionar comandos na modal
    addComandModal (newcomand, oldValue, name, key){
        if(oldValue === newcomand[1]){return}
        let isValidComand = true;
        let isNewComand = true;
        this.comandsModal.map(comando => {
            if(comando[0] === newcomand[0] && comando[1] === newcomand[1]){
                isValidComand = false
            }
            if(comando[0] === newcomand[0] && comando[1] !== newcomand[1]){
                isNewComand = false
            }
            return null
        })
        if(!isValidComand){return}
        if(isNewComand){
            if(newcomand[1] === true){
                newcomand[1] = 1
            } 
            if(newcomand[1] === false){
                newcomand[1] = 0
            } 
            this.showComandsModal.push({
                'name': name,
                'oldValue': oldValue,
                'newValue': newcomand[1],
                'comando': newcomand,
                'key': key,
            });
            this.comandsModal.push(newcomand);
        }else{
            this.comandsModal = this.comandsModal.map(([comando, valor]) => (comando === newcomand[0] ? [comando, newcomand[1]] : [comando, valor]));
            this.showComandsModal = this.showComandsModal.map((comand) => (comand.comando[0] === newcomand[0] ? [comand.comando[0], newcomand[1]] : [comand.comando[0], comand.comando[1]]));
        }
    }

    // Função para salvar os alarmes no data
    saveAlarms (){
        let newData = JSON.parse(JSON.stringify(store.getState().controlReducer.data));

        this.comands.some((item, index) => this.comandsModal.some(newitem => {
            if(item[0] === newitem[0]){
                this.comands[index][1] = newitem[1]
                this.showComands[index].newValue = newitem[1]
                this.comandsModal = this.comandsModal.filter(item => item[0] !== newitem[0]);
                this.showComandsModal = this.showComandsModal.filter(item => item.comando[0] !== newitem[0]);
                newData = newData.map(coluna => {
                    coluna.cards.map(card => {
                        card.cards_comando.comando_variavel.map(subitem => {
                            if(subitem.variavel.alarmHH?.command_variable === newitem[0]){
                                subitem.variavel.alarmHH.variavel.valor = newitem[1];
                            }else if(subitem.variavel.alarmH?.command_variable === newitem[0]){
                                subitem.variavel.alarmH.variavel.valor = newitem[1];
                            }else if(subitem.variavel.alarmLL?.command_variable === newitem[0]){
                                subitem.variavel.alarmLL.variavel.valor = newitem[1];
                            }else if(subitem.variavel.alarmL?.command_variable === newitem[0]){
                                subitem.variavel.alarmL.variavel.valor = newitem[1];
                            }
                            return subitem;
                        })
                        card.cards_comando.grupos.map(grupos => {
                            grupos.variaveis_agrupadas.map(variavel => {
                                if(variavel.variavel.alarmHH?.command_variable === newitem[0]){
                                    variavel.variavel.alarmHH.variavel.valor = newitem[1];
                                }else if(variavel.variavel.alarmH?.command_variable === newitem[0]){
                                    variavel.variavel.alarmH.variavel.valor = newitem[1];
                                }else if(variavel.variavel.alarmLL?.command_variable === newitem[0]){
                                    variavel.variavel.alarmLL.variavel.valor = newitem[1];
                                }else if(variavel.variavel.alarmL?.command_variable === newitem[0]){
                                    variavel.variavel.alarmL.variavel.valor = newitem[1];
                                }
                                return variavel;
                            })
                            return grupos;
                        })
                        return card;
                    })
                    return coluna;
                })
                store.dispatch(ChangeData(JSON.parse(JSON.stringify(newData))));
                store.dispatch(ChangeComand(JSON.parse(JSON.stringify(this.showComands))));
            }
            return null;
        }))
        
        this.showComandsModal.map(show => {
            newData = newData.map(coluna => {
                coluna.cards.map(card => {
                    card.cards_comando.comando_variavel.map(subitem => {
                        if(subitem.variavel.alarmHH?.command_variable === show.comando[0]){
                            subitem.variavel.alarmHH.variavel.valor = show.newValue;
                        }else if(subitem.variavel.alarmH?.command_variable === show.comando[0]){
                            subitem.variavel.alarmH.variavel.valor = show.newValue;
                        }else if(subitem.variavel.alarmLL?.command_variable === show.comando[0]){
                            subitem.variavel.alarmLL.variavel.valor = show.newValue;
                        }else if(subitem.variavel.alarmL?.command_variable === show.comando[0]){
                            subitem.variavel.alarmL.variavel.valor = show.newValue;
                        }
                        return subitem;
                    })
                    card.cards_comando.grupos.map(grupos => {
                        grupos.variaveis_agrupadas.map(variavel => {
                            if(variavel.variavel.alarmHH?.command_variable === show.comando[0]){
                                variavel.variavel.alarmHH.variavel.valor = show.newValue;
                            }else if(variavel.variavel.alarmH?.command_variable === show.comando[0]){
                                variavel.variavel.alarmH.variavel.valor = show.newValue;
                            }else if(variavel.variavel.alarmLL?.command_variable === show.comando[0]){
                                variavel.variavel.alarmLL.variavel.valor = show.newValue;
                            }else if(variavel.variavel.alarmL?.command_variable === show.comando[0]){
                                variavel.variavel.alarmL.variavel.valor = show.newValue;
                            }
                            return variavel;
                        })
                        return grupos;
                    })
                    return card;
                })
                return coluna;
            })
            store.dispatch(ChangeData(JSON.parse(JSON.stringify(newData))));
            return null;
        })

        this.comands=[
            ...this.comands,
            ...this.comandsModal
        ];
        this.showComands = [
            ...this.showComands,
            ...this.showComandsModal
        ];
 
        store.dispatch(ChangeComand(JSON.parse(JSON.stringify(this.showComands))));
        store.dispatch(ChangeModalAlarms(false));
        this.comandsModal = [];
        this.showComandsModal = [];
    }

    // Função para limpar os comandos da modal de alarms
    clearModalAlarms () {
        store.dispatch(ChangeModalAlarms(false));
        this.comandsModal = [];
        this.showComandsModal = [];
    };

    // Função para comçar os cards os cards
    StartCards(element, keepScale){
        if(element?.cards_comando?.comandoPoco?.active){
            let tempCards = []
            if(element.cards_comando.grupos.length > 0){
                element.cards_comando.grupos.map(grupo => {
                    tempCards.push({
                        maintenance : element.maintenance,
                        grupo: grupo,
                        switchvariable: element.cards_comando.switchvariable
                    });
                    return grupo;
                })
            }
            element.cards_comando.comando_variavel.map(item => {
                tempCards.push({...item, maintenance : element.maintenance});
                return item;
            })
            let cards = {
                id : element.id,
                name : element.cards_comando.name,
                cards: tempCards,
                active : element.cards_comando.comandoPoco.active
            }
            let startCard = tempCards[0]
            let name = store.getState().controlReducer.GraphData.name
            if(name){
                tempCards.map(currentcard => {
                    if(currentcard.grupo?.name === name){
                        startCard = currentcard;
                    }else if(currentcard?.variavel?.name === name){
                        startCard = currentcard;
                    }
                    return currentcard;
                })
            }
            let color = this.getCardColor(startCard)
            this.detailscontroller.StartGraph(startCard, null, color, keepScale)
            store.dispatch(ChangeCards(JSON.parse(JSON.stringify(cards))))
        }else{
            toast(i18n.t("message.control-service.start-cards"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    // Função para atualizar o card
    UpdateCards(data){
        let CurrentCard = store.getState().controlReducer.cards
        data.map(column => {
            column.cards.map(item => {
                if(item.id === CurrentCard.id){
                    this.StartCards(item, true);
                }
                return item;
            })
            return column;
        })
    }

    // Função para pegar a cor do card
    getCardColor(card){
        let color
        if(card?.grupo){
            color = this.getAlarm(card.grupo.variaveis_agrupadas[0].variavel.valor, card.grupo.variaveis_agrupadas[0].variavel.alarmL?.variavel.valor,
                card.grupo.variaveis_agrupadas[0].variavel.alarmLL?.variavel.valor, card.grupo.variaveis_agrupadas[0].variavel.alarmH?.variavel.valor,
                card.grupo.variaveis_agrupadas[0].variavel.alarmHH?.variavel.valor, card.grupo.variaveis_agrupadas[0].variavel.name.includes('Bomba'))
        }else{
            color = this.getAlarm(card.variavel.valor, card.variavel.alarmL?.variavel.valor,
                card.variavel.alarmLL?.variavel.valor, card.variavel.alarmH?.variavel.valor,
                card.variavel.alarmHH?.variavel.valor)
        }
        color = card.maintenance === '1' ? color = '#E1800E' : color === 6 ? '#00375E' : color === 2 ? '#FF3939' : color === 1 ? '#EABC1A' : color === 0 ? '#3C9' : '#006560';
        return color;
    }

    // Função para pegar o alarme
    getAlarm (valor, l, ll, h, hh){
        if(ll != null && (hh === null || hh === undefined) && ll === l){
            return 6;
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h){
            return 6;
        }
        if(hh === h && ll === l && hh === ll){
            return 6;
        }
        if(ll != null && parseFloat(ll) !== 0){
            if (valor <= ll){
                return 2;
            }
        }
        if(hh != null && parseFloat(hh) !== 0){
            if (valor >= hh){
                return 2;
            }
        }
        if(l != null && parseFloat(l) !== 0){
            if (valor <= l){
                return 1;
            }
        }
        if(h != null && parseFloat(h) !== 0){
            if (valor >= h){
                return 1;
            }
        }
        return 0;
    }

    async getCities(){
        try {
            let cities = await controlService.RequestCities();
            cities.authorized_cities.forEach(obj => {
                obj.id = obj.code_ibge;
                obj.nome = obj.name;
                delete obj.name;
                delete obj.code_ibge;
            })
            let list = [{id: '', nome: i18n.t("select.city")}];
            list.push(...cities.authorized_cities);
            store.dispatch(ChangeControlCities(list));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    filterEquipaments(city){
        store.dispatch(ChangeControlCity(city));
        if(city){
            store.dispatch(ChangeLoading(true));
            let newList = this.Equipaments.filter(equipament=> parseInt(equipament.city_code) === parseInt(city) || equipament.city_code === undefined);
            store.dispatch(ChangeEquipamentList(newList));
        }else{
            store.dispatch(ChangeEquipamentList(this.Equipaments));
        }
    }

    changeCity(equipamento){
        try {
            let currentCity = this.Equipaments.find(equip=> equip.id === equipamento);
            let newList = this.Equipaments.filter(equipament=> parseInt(equipament.city_code) === parseInt(currentCity.city.code_ibge) || equipament.city_code === undefined);
            if(currentCity.city){
                store.dispatch(ChangeEquipamentList(newList));
                store.dispatch(ChangeControlCity(currentCity.city.code_ibge));
                return currentCity.city.code_ibge;
            }else{
                store.dispatch(ChangeControlCity(''));
                return '';
            }
        } catch (error) {
            setTimeout(() => {
                this.changeCity(equipamento);
            }, 2000);
            console.log(error)
        }
    }
}